import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgAvalanche(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M4 0l8.278 8.763c.366-.35.848-.57 1.381-.57.41 0 .79.13 1.113.348.162-.372.42-.689.74-.914L11.14 2.941l.631-.677 4.675 5.011c.067-.007.134-.01.202-.01 1.143 0 2.07.981 2.07 2.192 0 .197-.033.384-.079.566A2.892 2.892 0 0120 12.5c0 1.201-.698 2.227-1.686 2.655l.799.846H4zm3.309.688l5.355 5.742-.631.677-5.355-5.742.63-.677z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Avalanche')(SvgAvalanche);
